<template>
  <div>
    <Hidrografia v-if="fichaActiva === 'hidrografia'" />
    <AvistamientoDeFauna v-if="fichaActiva === 'fauna'" />
    <AvistamientoDeFaunaAves v-if="fichaActiva === 'fauna_aves'" />
    <Vegetacion v-if="fichaActiva === 'vegetacion'" />
    <Edafologia v-if="fichaActiva === 'edafologia'" />
    <AreasDeEstudio v-if="fichaActiva === 'areas'" />
    <Localidades v-if="fichaActiva === 'poblacion'"  />
    <Municipios v-if="fichaActiva === 'poblacion_municipios'" />
    <UsoDeSuelo v-if="fichaActiva === 'usosuelo'" />
    <Minas v-if="fichaActiva === 'mineria'" />
    <PropiedadesDeSuelo v-if="fichaActiva === 'propiedadesSuelo'" />
    
  </div>
</template>

<script>
import "./fichas/fichaDiagnostico.scss";

import Hidrografia from "@/components/mapa-diagnostico/fichas/Hidrografia.vue";
import AvistamientoDeFauna from "@/components/mapa-diagnostico/fichas/AvistamientoDeFauna.vue";
import Vegetacion from "@/components/mapa-diagnostico/fichas/Vegetacion.vue";
import Edafologia from "@/components/mapa-diagnostico/fichas/Edafologia.vue";
import AreasDeEstudio from "@/components/mapa-diagnostico/fichas/AreasDeEstudio.vue";
import Localidades from "@/components/mapa-diagnostico/fichas/Localidades.vue";
import Municipios from "@/components/mapa-diagnostico/fichas/Municipios.vue";
import UsoDeSuelo from "@/components/mapa-diagnostico/fichas/UsoDeSuelo.vue";
import Minas from "@/components/mapa-diagnostico/fichas/Minas";
import PropiedadesDeSuelo from "@/components/mapa-diagnostico/fichas/PropiedadesDeSuelo";
import AvistamientoDeFaunaAves from "@/components/mapa-diagnostico/fichas/AvistamientoDeFaunaAves";

export default {
  computed: {
    temasExpandidos: {
      get() {
        return Object.entries(this.$store.state.mapa.temasExpandidos)
          .filter((t) => t[1])
          .map((t) => t[0]);
      },
    },
    fichaActiva: {
      get() {
        return this.$store.state.mapa.fichaActiva;
      },
    },
    
  },
  components: {
    Hidrografia,
    AvistamientoDeFauna,
    Vegetacion,
    Edafologia,
    AreasDeEstudio,
    Localidades,
    Municipios,
    UsoDeSuelo,
    Minas,
    PropiedadesDeSuelo,
    AvistamientoDeFaunaAves,
  },
};
</script>